import React from 'react'
import { AiOutlineCloseCircle } from "react-icons/ai";

function LayOver({children, closePopUp}) {
  return (
    <div 
    onClick={closePopUp}
    className={`bg-nightModeDark/85 h-full w-full flex justify-center items-center
     py-2.5 fixed top-0 right-0 z-[100]`}>
      <div 
      className='relative flex justify-center items-center w-[87%] md:w-2/4 2xl:w-1/4'
      onClick={(e) => {
      e.stopPropagation()
    }}>
        <button 
        onClick={closePopUp}
        className='absolute -top-6 -right-6 transition-all delay-300 ease-in-out transform hover:translate-x-3'>
          <AiOutlineCloseCircle className='text-white text-4xl' />
        </button>
        {children}
      </div>
    </div>
  )
}

export default LayOver
